/**
 * Extract a human-readable message from an axios (or similar) error.
 * @param {unknown} err
 * @returns {string}
 */
export function getApiErrorMessage(err) {
  if (err == null) return "";
  const data = err?.response?.data;
  if (data != null) {
    if (typeof data === "string" && data.trim()) return data.trim();
    if (typeof data.message === "string" && data.message.trim()) {
      const message = data.message.trim();
      if (/^server error\b/i.test(message) && typeof data.error === "string" && data.error.trim()) {
        return data.error.trim();
      }
      return message;
    }
    if (typeof data.error === "string" && data.error.trim()) return data.error.trim();
    if (Array.isArray(data.errors) && data.errors.length > 0) {
      const parts = data.errors
        .map((e) => {
          if (e == null) return "";
          if (typeof e === "string") return e;
          return e.msg || e.message || String(e);
        })
        .filter(Boolean);
      if (parts.length) return parts.join(". ");
    }
    if (
      data.errors &&
      typeof data.errors === "object" &&
      !Array.isArray(data.errors)
    ) {
      const parts = Object.values(data.errors)
        .map((e) => {
          if (e == null) return "";
          if (typeof e === "string") return e;
          return e.msg || e.message || String(e);
        })
        .filter(Boolean);
      if (parts.length) return parts.join(". ");
    }
  }
  if (typeof err.message === "string" && err.message.trim()) return err.message.trim();
  return "";
}
